import React, { useRef } from 'react';
import { Button, Modal } from 'antd';
import { useReactToPrint } from 'react-to-print';
import I9FormTemplate from './I9FormTemplate';

const I9Form = ({ openI9Template, setOpenI9Template, data }) => {
  const templateRef = useRef();

  const handleDownload = useReactToPrint({
    contentRef: templateRef,
    pageStyle: `
      @page {
        size: A4;
        margin: 10mm;
      }
      @media print {
        body {
          padding: 10px;
        }
        .ant-modal-content {
          box-shadow: none;
          padding: 0;
        }
        .ant-modal-header {
          display: none;
        }
        .ant-modal-body {
          padding: 0;
        }
      }
    `,
    documentTitle: 'I9-Form',
    removeAfterPrint: true
  });

  return (
    <Modal
      width={1000}
      open={openI9Template}
      closable={false}
      title={null}
      footer={null}
      maskClosable={true}
      onCancel={() => { setOpenI9Template (false); }}
      styles={{
        body: {
          padding: 0,
          backgroundColor: 'transparent',
          boxShadow: 'none',
          overflow: 'visible',
        },
        content: {
          backgroundColor: 'transparent',
          boxShadow: 'none'
        }
      }}
      modalRender={(node) => (
        <div style={{ position: 'relative', overflow: 'visible' }}>
          {/* Actual I-9 Form */}
          {node}

          {/* Floating Button */}
          <div
            style={{
              position: 'absolute',
              bottom: '72px',
              left: '50%',
              transform: 'translateX(-50%)',
              zIndex: 9999,
              pointerEvents: 'auto', // Ensure it can receive clicks
            }}
          >
            <Button style={{ borderRadius: '4px', height: 37 }} type="primary" onClick={handleDownload}>
              Print / Save as PDF
            </Button>
          </div>
        </div>
      )}
    >
      <I9FormTemplate ref={templateRef} data={data} />
    </Modal>
  );
};

export default I9Form;